import { useEffect, useState } from "react";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Main from "./components/Main/Main";
import "./App.css";

function getLanguageFromURL() {
  const params = new URLSearchParams(window.location.search);
  return params.get("lang");
}

function App() {
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const lang = getLanguageFromURL();
    if (lang) {
      setLanguage(lang);
    }
  }, []);

  return (
    <div className="app">
      <Header language={language} setLanguage={setLanguage} />
      <Main language={language} />
      <Footer />
    </div>
  );
}

export default App;
